
import { PropertiesService } from './properties.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CasaDiscografica, CaseDiscograficheResponse, CasaDiscograficaRequest, CasaDiscograficaConReferenteRequest } from '../interfaces/record-company';
import { NazioniResponse } from '../interfaces/utilities';

@Injectable({
	providedIn: "root"
})

export class RecordCompanyService {

    constructor(private httpClient: HttpClient, 
                private propService: PropertiesService) { }

	getAllRecordCompanies(): Observable<CaseDiscograficheResponse> {
        return this.httpClient.get<CaseDiscograficheResponse>(
            `${this.propService.getProp('apiPrefix')}/api/Public/CaseDiscografiche/Lista`
        );
    }
    
    getNations() : Observable<NazioniResponse> {
        return this.httpClient.get<NazioniResponse>(this.propService.getProp('apiPrefix')+'/api/Public/Servizi/ListaNazioni');
	}

    createRecordCompany(request: CasaDiscograficaRequest) {
		return this.httpClient.post<any>(this.propService.getProp('apiPrefix')+'/api/Public/CaseDiscografiche/Crea', request);
    }
    
    createRecordCompanyWithRL(request: CasaDiscograficaConReferenteRequest) {
		return this.httpClient.post<any>(this.propService.getProp('apiPrefix')+'/api/Public/CaseDiscografiche/RegistrazioneUnica', request);
	}
}